import 'highlight.js/styles/atom-one-dark.css'
import hljs from 'highlight.js/lib/common'

// Initialize Highlight.js on route updates
export const onRouteUpdate = () => {
  document.querySelectorAll('pre code:not(.hljs)').forEach((block) => {
    hljs.highlightElement(block)
  })
}

// Initial highlight on first load
if (typeof window !== 'undefined') {
  document.querySelectorAll('pre code:not(.hljs)').forEach((block) => {
    hljs.highlightElement(block)
  })
}
